// This file defines the routes used in the application.

export const ROUTES = {
    EMPTY_PATH: "",
    HOME: "/",
    LOGIN: "/login",
    PRIVACY: "/privacy",
    TERMS: "/terms",
    ABOUT_RAID: "/about-raid",
    API_KEY: "/api-key",
    INVITES: "/invites",
    CACHE_MANAGER: "/cache-manager",
    INVITE: "/invite",
    RAIDS: "/raids",
    MINT_RAID: "/raids/new",
    RAID_DISPLAY: "/raids/:prefix/:suffix",
    RAID_EDIT: "/raids/:prefix/:suffix/edit",
    RAID_HISTORY: "/raids/:prefix/:suffix/history",
    NOT_FOUND: "*",
    SERVICE_POINTS: "/service-points",
    SERVICE_POINT: "/service-points/:servicePointId",
    ORCID_SUCCESS: "/orcid/success",
    RAID_HISTORY_DETAIL: "/raids/:prefix/:suffix/:version",
}
